import { render, staticRenderFns } from "./ModalSignIn.vue?vue&type=template&id=60c867db&scoped=true"
import script from "./ModalSignIn.vue?vue&type=script&lang=js"
export * from "./ModalSignIn.vue?vue&type=script&lang=js"
import style0 from "./ModalSignIn.vue?vue&type=style&index=0&id=60c867db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c867db",
  null
  
)

export default component.exports